/* eslint-disable import/prefer-default-export */
export const startAccordeons = () => {
  const testEl = document.querySelector('[data-hidebox]');
  if (!testEl) return;
  document.addEventListener('click', (e) => {
    const accordLink = e.target.closest('[data-hideopen]');
    if (!accordLink) return;
    e.preventDefault();
    const accordWrap = accordLink.closest('[data-hidewrap]');
    const accordBox = accordWrap.querySelector('[data-hidebox]');
    if (!accordBox) return;

    if (accordBox.classList.contains('is-open')) {
      accordBox.style.height = `${accordBox.scrollHeight}px`;
      accordBox.classList.remove('is-open');
      accordLink.classList.remove('is-open');
      setTimeout(() => {
        accordBox.style.height = '';
      }, 0);
      return;
    }
    accordBox.style.height = 0;
    accordLink.classList.add('is-open');
    accordBox.classList.add('is-open');
    setTimeout(() => {
      accordBox.style.height = `${accordBox.scrollHeight}px`;
    }, 0);
    setTimeout(() => {
      accordBox.style.height = '';
    }, 1000);
  });
};
